export default "__VITE_ASSET__9d1215c2__"